import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { State } from 'interfaces/state'
import { Guards } from 'interfaces/guards'
import DeviceSettingsModule, { DeviceSettingsStateProps, DeviceSettingsDispatchProps } from 'components/features/pfm/DeviceSettingsModule/DeviceSettingsModule'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import { devicesGuard } from 'guards/authGuards'
import { deleteDeviceActionCreator } from 'actions/authActions'
import { toggleSettingsModalActionCreator } from 'actions/settingsActions'
import { createForgottenGuardError } from 'helpers/errorHelpers'

const mapStateToProps = (state: State): DeviceSettingsStateProps => {
  const { devices } = state.data.auth
  if (!devices) {
    throw createForgottenGuardError('DeviceSettingsModuleContainer', 'devicesGuard')
  }

  const { modal } = state.app.settings
  return {
    devices: getItemsFromCollection(devices),
    deletingId: modal && modal.type === 'delete-device' ? modal.id : null,
  }
}

const mapDispatchToProps: DeviceSettingsDispatchProps = {
  showRemoveDeviceModal: (deviceId) => toggleSettingsModalActionCreator({ id: deviceId, type: 'delete-device' }),
  hideModal: () => toggleSettingsModalActionCreator(null),
  removeDevice: deleteDeviceActionCreator,
}

const devicesGuards: Guards = [
  devicesGuard,
]

const DeviceSettingsModuleContainer = connectShadedLoadable<DeviceSettingsStateProps, DeviceSettingsDispatchProps, {}>(
  mapStateToProps, mapDispatchToProps, devicesGuards
)(DeviceSettingsModule)
export default DeviceSettingsModuleContainer
